import { Component, OnInit,ViewChild } from '@angular/core';
import { AuthService } from '../../../services-http/auth/auth.service';
import { Router } from '@angular/router';
import { ModalDirective } from 'ng-uikit-pro-standard';
import { NotificationService } from '../../../services-http/notification/notification.service'
import Swal from 'sweetalert2'


@Component({
  selector: 'app-dqc-center',
  templateUrl: './dqc-center.component.html',
  styleUrls: ['./dqc-center.component.scss']
})
export class DQCCenterComponent implements OnInit {
  @ViewChild('frame') frame: ModalDirective;

  user:any = JSON.parse(localStorage.getItem('currentUser'));
  userType:any;
  coopName:any;
  unreadNotifCount:any=0;
  @ViewChild('pop') pop: any;

  constructor(
    private authService: AuthService,
    private router: Router,
    public notification:NotificationService
  ) { 
    
    this.notification.connect(this.user);
          // register ang user bai using userid
            this.notification.ws.onopen = () => {
              console.log('Connected to server');
        
              const payload = {
                type: "register",
                user_id: this.user.iloginId
              };
              this.notification.ws.send(JSON.stringify(payload));
            };
          
            
            this.notification.ws.onmessage = (event) => {
              
              // this.notifList.unshift(JSON.parse(event.data));
              this.unreadNotifCount++;
              this.notification.playSound();
            };
          
            this.notification.ws.onclose = () => {
              // Swal.fire(
              //   'Error',
              //   'Connection closed, realtime notification is not available.',
              //   'error'
              // );
              
              console.log('Connection closed, realtime notification is not available.');
            };
          
        
            this.notification.ws.onerror = (error) => {
              // Swal.fire(
              //   'Error',
              //   'WebSocket error' + error,
              //   'error'
              // );
              console.log('WebSocket error' + error);

            };
  }


  ngOnInit() {
    this.getnotif();
  }

  closeNotificationPopover = () => {
    if (this.pop) {
      this.pop.hide();
    }
  };


  logout() {
    this.authService.logout();
  }
  
   
  gotoProfileView() {
    this.router.navigateByUrl('/endorsement-officer/cac-profile/' + this.user['userId'] + '/view');
  }

  getnotif(){
    this.notification.getNotification(this.user.iloginId)
      .subscribe((res: any) => {
        
        this.unreadNotifCount = res.filter((x:any) => x.status == 1).length;
    })
  }

}
